import React from "react";
import { makeStyles } from "@material-ui/core/styles";

import * as layouts from "../../Layouts/index";

import homedata from "../../data/Copyrights";
import NavAndFooter from "../Common/NavAndFooterContainer";
import LayoutContainer from "../../components/LayoutsContainer";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    display: "flex",
    justifyContent: "center",
    [theme.breakpoints.down("md")]: {
      backgroundColor: "#f6f6f6",
    },
  },
}));

const TermsAndConditions = () => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <LayoutContainer>
        {homedata?.data?.map((data, index) => {
          const Layout = layouts[data?.layout];
          return <Layout key={index} data={data} />;
        })}
      </LayoutContainer>
    </div>
  );
};
export default TermsAndConditions;
